<template>
	<el-card class="victim-card" :body-style="{ padding: '0px', display: 'flex', 'flex-wrap': 'wrap' }">
		<div class="victim-card-color" v-bind:class="backgroundColor"><i class="fas fa-notes-medical"></i></div>
		<div class="victim-card-content">
			<div class="title" v-bind:class="titleColor">{{title}}</div>
			{{victim.lastname}} {{victim.firstname}} <span v-if="victim.gender">({{victim.gender}})</span> <age v-bind:value="victim.age" v-bind:type="victim.ageType" /><br>
			{{victim.checkupState.name}}
		</div>
		<div class="victim-card-footer"><el-link v-bind:href="detailLink">Détail <i class="fas fa-angle-right"></i></el-link></div>
	</el-card>
</template>

<script>
import moment from 'moment';
import Age from '@/components/age.component.vue'

export default {
	name: 'VictimCard',
	components: { Age },
	props: ['victim'],
	computed: {
		backgroundColor() {
			return this.victim.checkupColor.toLowerCase() + '-background'
		},
		titleColor() {
			return this.victim.checkupColor.toLowerCase() + '-color'
		},
		detailLink() {
			return '#/checkups/' + this.victim.id + '/' + this.victim.checkupOrder
		},
		title() {
			return moment(this.victim.checkupReceiptDate).format('L LT')
		}
	}
};
</script>

<style scoped>

.victim-card {
	border: none;
	margin-bottom: 10px;
	height: 100px;
}

.victim-card > div {
	margin-bottom: 10px;
	height: 95px;
}

.victim-card-color {
	line-height: 78px;
	height: 78px;
	width: 78px;
	min-width: 78px;
	display: inline-block;
	border-width: 1px;
	border-style: solid;
	text-align: center;
	font-size: 28px;
}

.victim-card-content {
	padding: 10px 0 0 15px;
	display: inline-block;
	vertical-align: bottom;
	height: 69px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: calc(100% - 96px);
	border-top: 1px solid #EBEEF5;
}

.title {
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 4px;
}

.victim-card-footer {
	padding: 2px 10px;
	height: 14px;
	width: 100%;
	background-color: #f0f3f5;
	border: 1px solid #EBEEF5;
	border-top: 1px solid #c8ced3;
	text-align: right;
}

.victim-card-footer .el-link {
	font-size: 10px;
	font-weight: bold;
	color: #73818f;
	vertical-align: top;
}

</style>
